import React, { useEffect } from 'react'
import styles from './style.module.scss'
import { Route, Switch, useHistory, useLocation, useParams } from 'react-router'
import { getDataOptionsFromLocalStorage } from '@Root/helpers'
import { EntryProfilePage } from './Page'
import { EntryQualificationAwardPage } from './EntryQualificationAward'
import { useDispatch } from 'react-redux'
import { entryProfileActions } from '@Store/studies'
import { modalActions } from '@Store/modal'

export const EntryProfileDetails = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const pathname = location.pathname
  const { id: engagementId, contactId, entryProfileId } = useParams()
  const otherTabId = pathname.split('/')[9]

  useEffect(() => {
    getDataOptionsFromLocalStorage(['engagement_entry_profile'])
  }, [])

  useEffect(() => {
    if (entryProfileId && entryProfileId !== 'new' && otherTabId) {
      dispatch(entryProfileActions.get({ data: { entryProfileId, engagementId, contactId }, history }))
      return () => {
        dispatch(entryProfileActions.clearData())
      }
    }
  }, [entryProfileId, otherTabId])

  const onOpenDescriptionModal = (description, title) => {
    new Promise((resolve, reject) => {
      dispatch(
        modalActions.showModal('NotificationModal', {
          text: description,
          clickRejectButtonHandler: reject,
          clickResolveButtonHandler: resolve,
          title,
        })
      )
    }).finally(() => dispatch(modalActions.hideModal()))
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.sub_page}>
        <Switch>
          <Route
            path={'/home/studies/engagements/:contactId/:id/entry-profile/:entryProfileId?/entry-qualification-award/new'}
            component={() => EntryQualificationAwardPage({ onOpenDescriptionModal })}
            exact
          />
          <Route
            path={
              '/home/studies/engagements/:contactId/:id/entry-profile/:entryProfileId?/entry-qualification-award/:entryQualificationAwardId/:entryQualificationSubject?/:entryQualificationSubjectId?'
            }
            component={() => EntryQualificationAwardPage({ onOpenDescriptionModal })}
            exact
          />
          <Route component={() => EntryProfilePage({ onOpenDescriptionModal })} />
        </Switch>
      </div>
    </div>
  )
}
